<template>
  <b-row>
    <b-col>
      <div class="club-group">
        <div
          v-for="freq in Object.keys(frequencies)"
          :key="freq"
          :class="{selected: selectedOrderFrequencyComputed === freq}"
          class="club-card"
          @click="selectedOrderFrequencyComputed = freq"
        >
          <div class="card-inner">
            <div class="graphic">
              <div
                :style="{backgroundImage: `url('${frequencyImage}')`}"
                class="image"
              />
            </div>

            <div class="club-card-content">
              <div class="title">
                <h3>{{ frequency(freq) }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

import frequencyImage from '../../assets/delivery.svg'

export default {
  name: 'frequency-step',
  computed: {
    frequencyImage: function() {
      return frequencyImage
    },
    selectedOrderFrequencyComputed: {
      get() {
        return this.selectedFrequency
      },
      set(val) {
        this.SET_SELECTED_FREQUENCY(val)
      }
    },
    frequencies() {
      return this.getFrequencies(this.selectedOrderType)
    },
    ...mapState('somnambulistui', ['siteSettings', 'selectedOrderType', 'selectedFrequency']),
    ...mapGetters('somnambulistui', ['getFrequencies'])
  },
  methods: {
    frequency(val) {
      return this.$store.getters['somnambulistui/frequency'](val)
    },
    ...mapMutations('somnambulistui', ['SET_SELECTED_FREQUENCY']),
    formatedHtml(escapedHtml) {
      return escapedHtml.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

</style>
